import { render } from "./Welcome.vue?vue&type=template&id=b30f8416&scoped=true"
import script from "./Welcome.vue?vue&type=script&lang=js"
export * from "./Welcome.vue?vue&type=script&lang=js"

import "./Welcome.vue?vue&type=style&index=0&id=b30f8416&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b30f8416"

export default script